import { IinitialTenantFeedState } from 'interfaces/tenantFeed.interface';

const initialTenantFeedState: IinitialTenantFeedState = {
  tenant: null,
  getTenantFeed: () => Promise.resolve(false),
  isLoadingSetTenantFeed: true,
  profileVideosByBrand: [],
  getProfileVideosByBrand: () => Promise.resolve(false),
  profileProductsByBrand: [],
  getProfileProductsByBrand: () => Promise.resolve(false),
};

export default initialTenantFeedState;
